import { when } from 'cerebral/operators'

const hasSSOErrors = ({ state }) => {
  if(window.location.pathname.includes('/sso/error')) state.set('app.sso.hasError', true)
}

const throttleOnSSOErrors = ({ state, output }) => {
  if(!state.get('app.sso.hasError')) output()

  setTimeout(() => {
    output()
  }, state.get('app.sso.retryAfterSeconds') * 1000)
}
throttleOnSSOErrors.async = true

export default [
  hasSSOErrors,
  when('state:app.sso.hasError'), {
    true: [
      throttleOnSSOErrors
    ],
    false:[]
  }
]



// WEBPACK FOOTER //
// ./src/modules/app/chains/onSSOErrors.js